module.exports = __webpack_public_path__ + "img/H2.6b48439b.png";